import { render, staticRenderFns } from "./ruleGold.vue?vue&type=template&id=5fa0a9c6"
import script from "./ruleGold.vue?vue&type=script&lang=js"
export * from "./ruleGold.vue?vue&type=script&lang=js"
import style0 from "./ruleGold.vue?vue&type=style&index=0&id=5fa0a9c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports